<template>
    <li class="label-item" >
        <div class="the-label">
          <b-tooltip :label="labelValue.label" class="label-text" v-if="isTruncate"
                     position="is-left">
            {{ labelValue.label.substring(0,25) }} <span v-if="labelValue.label.length>25">[...]</span>
          </b-tooltip>

          <div  class="label-text"  v-else>
            {{ labelValue.label}}
          </div>
        </div>
        <span class="dots"></span>
        <span class="value" :class="{'is-sorted':isSorted}">{{ labelValue.value }}</span>
    </li>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: 'CardLabelValueItem',
        props: {
            labelValue: {
                type: Object,
                require: true
            }
        },
      data() {
        return {
          isSorted:false,
        }
      },
      computed: {
        ...mapState({
          isLargeDesktop: state => state.settings.isLargeDesktop,
          isSmallDesktop: state => state.settings.isSmallDesktop,
          isTablet: state => state.settings.isTablet,
          isPhone: state => state.settings.isPhone,
          sort: state => state.searchMachines.sort,
        }),
        isTruncate() {
          return !this.isTablet && !this.isPhone && !this.isSmallDesktop
        },
      },
      watch : {
          sort() {
            this.isSorted=false
            var sortTest = this.sort.split('/')
            if(sortTest[0]===this.labelValue.code) {
              this.isSorted=true
            }
          }
      }
    }
</script>

<style lang="scss">
.label-item {
    position: relative;
    display: flex;
    margin-bottom: 10px;
    //min-height: 30px;
    font-size: 13px;
    background-image: url('~@/assets/img/spaced-dot.svg');
    background-position: center center;
    background-repeat: repeat-x;
    background-size: 7px 2px;
    width:100%;

    @media #{$mq_phone} {
        display: block;
        background: none;
        margin-bottom: 10px;

    }

    .the-label {
        display: flex;
        align-items: center;
        background-color: $white;
      font-weight:bold;

        @media #{$mq_phone} {
            display: block;
        }

        &.has-drawing-code {
            flex-direction: column;
            justify-content: flex-start;
            margin-top: 6px;
        }

        .label-text {
            padding-right: 10px;
          text-align:left;
          @media #{$mq_phone} {
            text-align:center;
          }
        }
    }

    .dots {
        flex: 1 1 auto;

        @media #{$mq_phone} {
            display: none;
        }
    }

    .value {
        display: flex;
        align-items: center;
        //width: 200px;
        padding-left: 10px;
        background-color: $white;
        color: $medium-grey;
      text-align:right;

       //@media #{$mq_small_desktop} {
       //    width: 50px;
       //}

        @media #{$mq_phone} {
            display: block;
            width: 100%;
            padding-left: 0;
            margin-top: 5px;
          text-align:center;
        }

      &.is-sorted {
        color:$brand-red;
        font-weight:bold
      }
    }
}
</style>
